/**
 * El aviso de la newsletter: cuando sale, en que fase, y que se recuerda.
 *
 * Es un `<dialog>` nativo. En escritorio (desde 750 px) se abre con
 * `showModal()`: centrado, con velo, Escape y clic fuera lo cierran, y el
 * scroll de la pagina se bloquea con el mismo atributo que usa Horizon
 * (`scroll-lock` en `<html>`). En movil se abre con `show()`: tarjeta abajo,
 * sin velo, la pagina sigue viva. Por eso no pasa por el `dialog-component`
 * de Horizon, que es siempre modal y al cerrar devuelve el scroll a donde
 * estaba al abrir (a 0 si no abrio el). Ver el comentario de cabecera de
 * `sections/natnatura-captacion.liquid`.
 *
 * DOS FASES (Tamara, por Fran, 17/09/2026; y Fran, 17/09 por la noche: «en
 * la ficha de producto hay que ofrecer en el popup, solo en esa pagina, el
 * 20 %»):
 *   1. −10 %, en cualquier pagina que no sea una ficha, cuando llega lo
 *      primero de dos cosas: los segundos del ajuste (20) o el porcentaje de
 *      scroll del ajuste (50 %).
 *   2. −20 %, en la ficha de producto, SIEMPRE (haya visto o no la primera),
 *      a los segundos de su ajuste (5). Una vez.
 * Lo que se apunta en `sessionStorage` es que una fase se cerro: quien cierra
 * la 2 no vuelve a ver ninguna en esa pestana; quien cierra la 1 solo vera la
 * 2 (en la ficha). Muere al cerrar la pestana.
 *
 * Y solo con la pestana VISIBLE: un aviso que se abre en una pestana de fondo
 * se encuentra ya cerrado al volver, o peor, ya contado como visto.
 *
 * EL SCROLL NO ES EL DE LA VENTANA. En Horizon 4 el documento no se desplaza:
 * lo hace `.page-wrapper`, con la cabecera fija fuera. `window.scrollY` vale 0
 * en todo momento en escritorio, asi que un umbral leido de ahi no dispara
 * NUNCA. Se busca el contenedor real y se cae a `document.scrollingElement`.
 *
 * NO SALE:
 *   - si el visitante ya se suscribio desde aqui, o ya cerro la fase que
 *     tocaria, mientras duren los dias de silencio (si se pudo recordar).
 *     EN LA PORTADA NO HAY SILENCIO (Tamara, 23/09/2026: «que no solo salga
 *     1 vez sino siempre que se acceda a la home page»): alli se ignoran las
 *     marcas de «cerrado» de `localStorage` y de la sesion; solo la de
 *     «suscrito» lo calla, porque ya tiene su codigo;
 *   - si llego con un descuento puesto (?discount=): ya tiene el suyo;
 *   - mientras haya un modal abierto (busqueda, carrito, la tabla de la
 *     ficha): dos cosas encima de la pagina a la vez es una de mas.
 *
 * NADA DURADERO SE GUARDA SIN CONSENTIMIENTO. Recordar «lo cerro» o «se
 * suscribio» durante treinta dias es una preferencia, y en la UE eso pide
 * consentimiento de cookies. Se pregunta a `Shopify.customerPrivacy` (la API
 * que gobierna el aviso de cookies de Shopify): con las preferencias
 * permitidas se escribe en `localStorage`; si no, se deja apuntado y se
 * escribe cuando llegue el consentimiento (`visitorConsentCollected`). Si
 * nunca llega, no se escribe, y el aviso volvera a salir en otra visita: es
 * el fallo menos malo.
 *
 * LA CAMPAÑA (13-21/10/2026). Si el interruptor de `snippets/natnatura-campana`
 * ha puesto `data-nn-campana` en <html>, la fase es `campana` en todas las
 * paginas, tambien en la ficha: sale al reloj o al scroll, como la primera,
 * con sus propias marcas de «cerrado» (quien cerro el −10 % la semana pasada
 * tiene que poder ver la oferta) y con la etiqueta de cliente de su ajuste
 * (`newsletter,popup-vip5`). La vuelta de Shopify trae `gracias-campana` y el
 * «gracias» no ensena codigo: el VIP5 se lo manda Klaviyo.
 *
 * DESPUES DE ENVIAR. Al formulario se le pone un `return_to` con la ruta
 * actual y `?nn-boletin=gracias` (o `gracias2`), y la etiqueta de cliente de
 * la fase (`newsletter,popup-10` / `popup-20`) para que se le mande el codigo
 * que toca. Shopify vuelve a la ruta, el aviso se abre en su estado
 * «gracias», se marca «suscrito» y la marca se quita de la URL. Si Shopify
 * devuelve un error del formulario, el bloque de correo lo pinta dentro del
 * aviso y este se abre en el acto.
 */
(() => {
  const SEL = 'dialog.nn-captacion';
  const MARCA = 'nn-boletin';
  const CAMPANA = 'campana';
  /** La marca de vuelta de Shopify segun la fase que mando el formulario. */
  const VUELTAS = { 1: 'gracias', 2: 'gracias2', [CAMPANA]: 'gracias-campana' };
  const DIA = 24 * 60 * 60 * 1000;
  const ESCRITORIO = '(min-width: 750px)';

  const contenedorDeScroll = () =>
    document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;

  /** Cuanto se ha bajado, de 0 a 1. */
  const recorrido = (caja) => {
    const alto = caja.scrollHeight - caja.clientHeight;
    return alto > 0 ? caja.scrollTop / alto : 0;
  };

  // --- La memoria, con permiso ---------------------------------------------

  const leer = (clave) => {
    try {
      return window.localStorage.getItem(clave);
    } catch {
      return null; // navegacion privada, o datos de sitio bloqueados
    }
  };

  const leerSesion = (clave) => {
    try {
      return window.sessionStorage.getItem(clave);
    } catch {
      return null;
    }
  };

  const escribirSesion = (clave, valor) => {
    try {
      window.sessionStorage.setItem(clave, valor);
    } catch {
      /* sin sesion no hay segunda fase; la primera sigue saliendo */
    }
  };

  const borrarSesion = (clave) => {
    try {
      window.sessionStorage.removeItem(clave);
    } catch {
      /* nada que borrar */
    }
  };

  // --- Klaviyo: identificar al que se suscribe ------------------------------
  // El alta va a Shopify (formulario de cliente) y Klaviyo la recibe por la
  // integracion, pero ESTE navegador seguia anonimo para klaviyo.js: sus
  // «Carrito actualizado» no llegaban al perfil y el carrito abandonado no
  // salia (06/10/2026). El formulario recarga la pagina, asi que el email se
  // deja en la sesion al enviar y se identifica a la vuelta con la marca de
  // «gracias»; despues se borra.

  const CLAVE_IDENTIFICAR = 'nn-boletin-klaviyo-email';

  const identificarEnKlaviyo = (email) => {
    const k = window.klaviyo;
    if (k && typeof k.identify === 'function') {
      Promise.resolve(k.identify({ email })).catch((e) => console.warn('[natnatura-captacion] Klaviyo identify:', e));
      return;
    }
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['identify', { email }]);
  };

  /** Lo que se escribiria en localStorage si se pudiera. Se vacia al escribirlo. */
  const pendiente = new Map();

  const privacidad = () => (window.Shopify && window.Shopify.customerPrivacy) || null;

  /**
   * Si se pueden guardar preferencias. `preferencesProcessingAllowed` ya
   * contempla las regiones donde no hace falta pedir permiso; si la API no
   * esta cargada todavia, la respuesta es NO: se escribe cuando llegue.
   */
  const permitido = () => {
    const cp = privacidad();
    if (!cp) return false;
    try {
      if (typeof cp.preferencesProcessingAllowed === 'function') return Boolean(cp.preferencesProcessingAllowed());
      const c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
      return Boolean(c && c.preferences === 'yes');
    } catch {
      return false;
    }
  };

  const vaciaPendiente = () => {
    if (!permitido()) return;
    pendiente.forEach((valor, clave) => {
      try {
        window.localStorage.setItem(clave, valor);
      } catch {
        /* si no se puede guardar, el aviso volvera a salir */
      }
    });
    pendiente.clear();
  };

  const escribir = (clave, valor) => {
    pendiente.set(clave, valor);
    vaciaPendiente();
  };

  /** Carga la API de consentimiento si Shopify no la ha puesto ya. */
  const cargaPrivacidad = () => {
    if (privacidad()) return;
    const S = window.Shopify;
    if (!S || typeof S.loadFeatures !== 'function') return;
    try {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => vaciaPendiente());
    } catch {
      /* sin API no se guarda nada, que es lo que toca */
    }
  };

  document.addEventListener('visitorConsentCollected', vaciaPendiente);

  // --- Abrir y cerrar -------------------------------------------------------

  const esEscritorio = () => window.matchMedia(ESCRITORIO).matches;

  const abrir = (dialogo) => {
    if (dialogo.open) return;
    dialogo.classList.remove('nn-captacion--cerrando');
    if (esEscritorio()) {
      dialogo.classList.add('nn-captacion--modal');
      dialogo.showModal();
      document.documentElement.setAttribute('scroll-lock', '');
    } else {
      dialogo.classList.remove('nn-captacion--modal');
      dialogo.show();
    }
  };

  const cerrar = (dialogo) => {
    if (!dialogo.open) return;
    let hecho = false;
    const fin = () => {
      if (hecho) return;
      hecho = true;
      dialogo.classList.remove('nn-captacion--cerrando');
      dialogo.close();
      if (dialogo.classList.contains('nn-captacion--modal') && !document.querySelector('dialog[open][scroll-lock]')) {
        document.documentElement.removeAttribute('scroll-lock');
      }
    };
    dialogo.classList.add('nn-captacion--cerrando');
    dialogo.addEventListener('animationend', fin, { once: true });
    // Por si la animacion no corre (movimiento reducido, pestana de fondo).
    window.setTimeout(fin, 400);
  };

  // --- La marca de vuelta de Shopify ----------------------------------------

  const consulta = new URLSearchParams(location.search);

  const quitaLaMarca = () => {
    const u = new URL(location.href);
    u.searchParams.delete(MARCA);
    history.replaceState(history.state, '', u.pathname + u.search + u.hash);
  };

  const arranca = (dialogo) => {
    const clave = dialogo.dataset.clave;
    const segundos = Number(dialogo.dataset.segundos || 20);
    // `data-segundos-2`: el guion antes de un digito no se camelCasea, asi que
    // la clave del dataset es literal (con `.segundos2` el ajuste no llegaba).
    const segundos2 = Number(dialogo.dataset['segundos-2'] || 5);
    const umbral = Number(dialogo.dataset.scroll || 50) / 100;
    const silencio = Number(dialogo.dataset.silencio || 30);
    const enFicha = dialogo.dataset.ficha === '1';
    const claveAlta = clave + '-suscrito';
    const claveFase = clave + '-fase';
    const claveCierre = (fase) => clave + '-cerrado-' + fase;

    const formulario = dialogo.querySelector('form');
    const gracias = dialogo.querySelector('.nn-captacion__gracias');
    const texto = dialogo.querySelector('.nn-captacion__texto');

    /**
     * Que fase toca en esta pagina: en campaña, la de la campaña en todas; si
     * no, en la ficha siempre la 2 (−20 %) y en el resto la 1.
     */
    const enCampana = document.documentElement.hasAttribute('data-nn-campana');
    const fase = enCampana ? CAMPANA : enFicha ? 2 : 1;
    const descuento = fase === 2 ? dialogo.dataset.descuento2 : dialogo.dataset.descuento;
    const etiquetasCliente =
      fase === CAMPANA
        ? dialogo.dataset.etiquetasCampana || 'newsletter'
        : 'newsletter,popup-' + (descuento || (fase === 2 ? '20' : '10'));

    // El nombre del dialogo sigue al titulo que se ve, si tiene id (el de la
    // primera fase y el de la campaña; la segunda conserva el de la primera).
    const pintaFase = (f) => {
      dialogo.querySelectorAll('[data-nn-fase]').forEach((el) => {
        el.hidden = el.dataset.nnFase !== String(f);
      });
      const titulo = dialogo.querySelector('.nn-captacion__texto .nn-captacion__titulo[id]:not([hidden])');
      if (titulo) dialogo.setAttribute('aria-labelledby', titulo.id);
    };

    const enGracias = (f) => {
      pintaFase(f);
      if (texto) texto.hidden = true;
      if (gracias) gracias.hidden = false;
    };

    const cierraYRecuerda = () => {
      cerrar(dialogo);
      escribir(claveCierre(fase), String(Date.now()));
      // Cerrar la primera abre la puerta a la segunda; cerrar la segunda, a
      // nada. La de la campaña lleva su propia marca y no toca las otras dos.
      if (fase === CAMPANA) escribirSesion(claveCierre(fase), '1');
      else escribirSesion(claveFase, fase === 1 ? '2' : '3');
    };

    dialogo.querySelectorAll('[data-nn-captacion-cerrar]').forEach((b) => b.addEventListener('click', cierraYRecuerda));

    // Escape: en modal el navegador dispara `cancel`; en no modal, nada. Se
    // atienden los dos caminos y se cierra con animacion.
    dialogo.addEventListener('cancel', (e) => {
      e.preventDefault();
      cierraYRecuerda();
    });
    dialogo.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      cierraYRecuerda();
    });

    // Clic en el velo: en modal el `<dialog>` ocupa la pantalla y la caja va
    // dentro, asi que un clic cuyo destino es el propio dialogo es fuera.
    dialogo.addEventListener('click', (e) => {
      if (e.target === dialogo) cierraYRecuerda();
    });

    // `return_to` con nuestra marca y la etiqueta de la fase, para reconocer
    // la vuelta y para que el codigo que se envie sea el que toca.
    if (formulario) {
      if (!formulario.querySelector('input[name="return_to"]')) {
        const vuelta = document.createElement('input');
        vuelta.type = 'hidden';
        vuelta.name = 'return_to';
        const u = new URL(location.href);
        u.searchParams.delete(MARCA);
        u.searchParams.set(MARCA, VUELTAS[fase]);
        vuelta.value = u.pathname + u.search;
        formulario.append(vuelta);
      }
      if (!formulario.querySelector('input[name="contact[tags]"]')) {
        const etiquetas = document.createElement('input');
        etiquetas.type = 'hidden';
        etiquetas.name = 'contact[tags]';
        etiquetas.value = etiquetasCliente;
        formulario.append(etiquetas);
      }
      formulario.addEventListener('submit', () => {
        const campo = formulario.querySelector('input[type="email"], input[name="contact[email]"]');
        const email = campo ? campo.value.trim() : '';
        if (email) escribirSesion(CLAVE_IDENTIFICAR, email);
      });
    }

    // 1. Vuelta de Shopify tras suscribirse: gracias, y no se vuelve a pedir.
    const marca = consulta.get(MARCA);
    const faseDeLaVuelta = Object.keys(VUELTAS).find((f) => VUELTAS[f] === marca);
    if (faseDeLaVuelta) {
      const emailSuscrito = leerSesion(CLAVE_IDENTIFICAR);
      if (emailSuscrito) {
        borrarSesion(CLAVE_IDENTIFICAR);
        identificarEnKlaviyo(emailSuscrito);
      }
      quitaLaMarca();
      enGracias(faseDeLaVuelta);
      escribir(claveAlta, '1');
      escribirSesion(claveAlta, '1');
      escribirSesion(claveFase, '3');
      abrir(dialogo);
      return;
    }

    pintaFase(fase);

    // «Recoger cupón» de la pagina del carrito (natnatura-carrito.js) abre
    // este mismo pop-up a mano, aunque este en silencio o ya cerrado: quien
    // pulsa el boton lo esta pidiendo. Se registra ANTES de los silencios.
    // Y la barra de anuncios entera (Tamara, 23/09: «en el banner verde de
    // arriba del todo, cuando se haga clic, que salga el popup de la
    // newsletter»): un clic en cualquier aviso lo abre, tambien en el que
    // enlaza a `#boletin`; los botones de la barra (flechas del carrusel) se
    // respetan. Fuera de la barra, el enlace a `#boletin` abre el pop-up si
    // el ancla no esta a la vista (el boletin del pie solo se pinta en la
    // ficha, CSS seccion 50). Por delegacion en `document`, que `theme dev`
    // sustituye las secciones al recargar.
    // La marca en <html> pone el cursor de mano en la barra (CSS seccion 57),
    // que en iOS hace falta para que llegue el clic delegado. Va aqui y no
    // como `html:has(dialog.nn-captacion)`: ese `:has()` en <html> obligaba
    // a recalcular los estilos de la pagina entera con cada nodo que se
    // anadia al documento (22/10/2026, PageSpeed).
    document.documentElement.setAttribute('data-nn-captacion', '');
    document.addEventListener('click', (e) => {
      const barra = e.target.closest('[id*="header_announcements"]');
      if (barra && !e.target.closest('button')) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('nn:captacion:abrir', { bubbles: true }));
        return;
      }
      const enlace = e.target.closest('a[href$="#boletin"]');
      if (!enlace) return;
      const ancla = document.getElementById('boletin');
      if (ancla && ancla.offsetParent !== null) return;
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('nn:captacion:abrir', { bubbles: true }));
    });

    // Con otro modal abierto (carrito, busqueda) no se abre encima.
    document.addEventListener('nn:captacion:abrir', () => {
      const otro = Array.from(document.querySelectorAll('dialog[open]')).some((d) => d !== dialogo);
      if (otro) return;
      pintaFase(fase);
      abrir(dialogo);
    });

    // 2. Vuelta de Shopify con un error del formulario: que se vea.
    if (dialogo.querySelector('[id^="Email-signup__message-error"]')) {
      abrir(dialogo);
      return;
    }

    // 3. Ya suscrito, ya pasadas las dos fases, o cerrada esta hace poco.
    // En la portada solo cuenta «suscrito»: sale en cada visita. Sin
    // consentimiento de cookies «suscrito» no llega a localStorage, asi que
    // tambien se mira la marca de sesion que pone la vuelta de Shopify.
    if (leer(claveAlta) || leerSesion(claveAlta)) return;
    const portada = document.documentElement.dataset.nnPlantilla === 'index';
    const sesion = leerSesion(claveFase);
    if (!portada) {
      if (fase === CAMPANA) {
        if (leerSesion(claveCierre(fase))) return;
      } else {
        if (sesion === '3') return;
        if (sesion === '2' && fase === 1) return; // cerro la 1 y no es una ficha: nada
      }
      const cerrado = Number(leer(claveCierre(fase)));
      if (cerrado && Date.now() - cerrado < silencio * DIA) return;
    }
    if (consulta.has('discount')) return;
    // En la pagina del test no sale solo: el test ofrece su propio 10 % y el
    // aviso se abria encima a los 20 s, a mitad de las preguntas (24/09). Con
    // clic en la barra de anuncios sigue abriendose.
    if (document.querySelector('[data-nn-test]')) return;

    // 4. A esperar el disparo: la fase 1 y la de la campaña al reloj o al
    // scroll, la 2 al reloj.
    const caja = contenedorDeScroll();
    let pedido = false;
    let hecho = false;

    const ocupado = () =>
      Array.from(document.querySelectorAll('dialog[open]')).some((d) => d !== dialogo);

    // Nunca a mitad de un gesto (auditoria de movil, 08/10/2026): abierto
    // justo cuando el dedo baja, el pop-up se llevaba el toque que iba a un
    // boton de la pagina. Espera a que pase CALMA sin tocar, desplazar ni
    // teclear; el `vigila` de abajo lo reintenta hasta que la haya.
    const CALMA = 600;
    let ultimoGesto = 0;
    const gesto = () => {
      ultimoGesto = Date.now();
    };
    const GESTOS = ['pointerdown', 'touchstart', 'keydown', 'wheel'];
    GESTOS.forEach((tipo) => document.addEventListener(tipo, gesto, { capture: true, passive: true }));
    caja.addEventListener('scroll', gesto, { passive: true });
    window.addEventListener('scroll', gesto, { passive: true });

    const puede = () =>
      document.visibilityState === 'visible' && !ocupado() && Date.now() - ultimoGesto >= CALMA;

    const intenta = () => {
      if (hecho || !pedido) return;
      if (!puede()) return;
      hecho = true;
      suelta();
      abrir(dialogo);
    };

    const pide = () => {
      if (pedido) return;
      pedido = true;
      intenta();
    };

    const mira = () => {
      if (pedido) return;
      if (recorrido(caja) >= umbral) pide();
    };

    const reloj = window.setTimeout(pide, (fase === 2 ? segundos2 : segundos) * 1000);
    // Mientras este pedida y no pueda (pestana de fondo, otro modal), se
    // reintenta cada medio segundo. Se para en cuanto abre.
    const vigila = window.setInterval(intenta, 500);

    const suelta = () => {
      window.clearTimeout(reloj);
      window.clearInterval(vigila);
      caja.removeEventListener('scroll', mira);
      window.removeEventListener('scroll', mira);
      document.removeEventListener('visibilitychange', intenta);
      GESTOS.forEach((tipo) => document.removeEventListener(tipo, gesto, { capture: true }));
      caja.removeEventListener('scroll', gesto);
      window.removeEventListener('scroll', gesto);
    };

    const conScroll = fase !== 2;
    if (conScroll) {
      caja.addEventListener('scroll', mira, { passive: true });
      window.addEventListener('scroll', mira, { passive: true });
    }
    document.addEventListener('visibilitychange', intenta);
    // Por si la pagina ya llega bajada (recarga, volver atras). Tras el primer
    // fotograma y no al arrancar (22/10/2026 por la noche, PageSpeed): leer el
    // scroll ahora obligaba a maquetar la pagina entera dentro de este script,
    // 266 ms en la portada con la CPU de PSI. Despues del fotograma la
    // maquetacion ya esta hecha y la lectura no cuesta nada; el aviso tarda
    // igual en salir (espera a CALMA de todos modos).
    if (conScroll) requestAnimationFrame(() => window.setTimeout(mira, 0));
  };

  const inicia = () => {
    const dialogo = document.querySelector(SEL);
    if (!dialogo) return;
    cargaPrivacidad();
    arranca(dialogo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inicia, { once: true });
  } else {
    inicia();
  }
})();
